import React from 'react';
import { withRouter } from 'react-router-dom';
import searchQuery from 'query-string';
import { get } from 'lodash';

// local dependencies
import { memberDetailsPriorAuthorizationsEntityWidget as MemberDetailsPriorAuthorizationsEntityWidgetView } from 'ui/views/widgets/memberDetailsPriorAuthorizationsEntityWidget';
import { MemberDetailsPriorAuthorizationsEntityWidgetService } from 'services/memberDetailsPriorAuthorizationsEntityWidget';
import { SERVICE_RESPONSE_STATUS } from 'constants/common';
import { DASHBOARD_SUB_ROUTES } from 'constants/route-paths';
import * as backRoute from 'utils/backRoute';

/**
 * @type {class}
 * @desc A React container/smart component to render a React presentational/dumb component (view).
 * @example
 * import { MemberDetailsPriorAuthorizationsEntityWidget } from 'ui/containers/MemberDetailsPriorAuthorizationsEntityWidget';
 *
 * // render
 * <MemberDetailsPriorAuthorizationsEntityWidget propName='propValue'/>
 */
class _MemberDetailsPriorAuthorizationsEntityWidget extends React.Component {
    
    /**
     * @param {object} props - props
     */
    constructor( props ) {
        super( props );

        this.memberDetailsPriorAuthorizationsEntityWidgetService = new MemberDetailsPriorAuthorizationsEntityWidgetService();

        this.data = {
            requestPayload: this.props.requestPayload
        };

        this.state = {
            isFetching: true,
            networkStatus: null,
            componentData: null
        };

        this.fetchComponentData();
    }

    /**
     * Make request and fetch component data
     */
    fetchComponentData = async () => {
        log.debug( 'MemberDetailsPriorAuthorizationsEntityWidget.fetchComponentData()' );

        this.memberDetailsPriorAuthorizationsEntityWidgetService.cancel();

        try {
            const { status, data } = await this.memberDetailsPriorAuthorizationsEntityWidgetService.fetchComponentData( {
                url: this.props.widget.url,
                data: this.data.requestPayload
            } );

            if ( SERVICE_RESPONSE_STATUS.SUCCESS !== status ) {
                this.setState( {
                    isFetching: false,
                    networkStatus: SERVICE_RESPONSE_STATUS.FAILURE
                } );
            } else {
                this.setState( {
                    isFetching: false,
                    networkStatus: SERVICE_RESPONSE_STATUS.SUCCESS,
                    componentData: data
                } );
            }
        } catch ( e ) {
            this.setState( {
                isFetching: false,
                networkStatus: SERVICE_RESPONSE_STATUS.FAILURE,
            } );
        }
    }

    /**
     * @desc Action handler for column action and group action
     */
    handleActionClick = ( { type = 'column', value = {}, item = {} } = {} ) => {
        log.debug( 'MemberDetailsPriorAuthorizationsEntityWidget.handleActionClick()' );

        const memberId = get( this.data, 'requestPayload.context.memberId', null );

        // prepare back-route state payload
        const backRouteState = backRoute.encode( {
            pathname: this.props.location.pathname,
            payload: {
                entitiesActiveTabIndex: this.props.tabIndex,
                memberId
            }
        } );

        if ( 'column' === type && 'eocNumber' === value.name ) {
            this.props.history.push( {
                pathname: DASHBOARD_SUB_ROUTES.PRIOR_AUTH_DETAILS,
                state: { ...backRouteState, memberId },
                search: searchQuery.stringify( {
                    eocNumber: item.values.eocNumber,
                } )
            } );
        }

    }

    /**
     * Free up resources and cancel all http requests
     */
    componentWillUnmount() {
        log.debug( 'MemberDetailsPriorAuthorizationsEntityWidget.componentWillUnmount()' );

        this.memberDetailsPriorAuthorizationsEntityWidgetService.cancel();
    }

    /**
     * @desc Render a React view component
     */
    render() {
        return (
            <MemberDetailsPriorAuthorizationsEntityWidgetView
                { ...this.state }
                requestPayload={ this.data.requestPayload }
                onActionClick={ this.handleActionClick }
            />
        );
    }
}

// set display name
_MemberDetailsPriorAuthorizationsEntityWidget.displayName = 'MemberDetailsPriorAuthorizationsEntityWidget';

// set default props
_MemberDetailsPriorAuthorizationsEntityWidget.defaultProps = {};

// prop types
_MemberDetailsPriorAuthorizationsEntityWidget.propTypes = {};

export const MemberDetailsPriorAuthorizationsEntityWidget = withRouter( _MemberDetailsPriorAuthorizationsEntityWidget );
